import { RootState } from "../store";

/**
 * @param state The app state
 * @returns the index of the step the user is on
 */
export function selectActiveWizardStepIndex(state: RootState): number {
  return state.wizard.activeStepIndex;
}

/**
 * @param state The app state
 * @returns the index of the furthest step the user has reached
 */
export function selectFurthestWizardStepIndex(state: RootState): number {
  return state.wizard.furthestStepIndex;
}

/**
 * @param state The app state
 * @returns the key of the step the user is on, or undefined if no wizard is running
 */
export function selectActiveWizardStepKey(
  state: RootState,
): string | undefined {
  return state.wizard.stepKeys.at(state.wizard.activeStepIndex);
}

/**
 * @param state The app state
 * @returns the keys of the steps of the running wizard
 */
export function selectWizardStepKeys(state: RootState): string[] {
  return state.wizard.stepKeys;
}
